const FormStates = {
    FORM_SAVING: 'FORM_SAVING',
    FORM_SAVING_SUCCESS: 'FORM_SAVING_SUCCESS',
    FORM_SAVING_FAILURE: 'FORM_SAVING_FAILURE',
    FORM_PENDING_SAVING: 'FORM_PENDING_SAVING',
    FORM_PENDING_SAVING_SUCCESS: 'FORM_PENDING_SAVING_SUCCESS',
    FORM_PENDING_SAVING_FAILURE: 'FORM_PENDING_SAVING_FAILURE',
    FORM_PUBLISHING: 'FORM_PUBLISHING',
    FORM_PUBLISHING_SUCCESS: 'FORM_PUBLISHING_SUCCESS',
    FORM_PUBLISHING_FAILURE: 'FORM_PUBLISHING_FAILURE',
    FORM_HIDING: 'FORM_HIDING',
    FORM_HIDING_SUCCESS: 'FORM_HIDING_SUCCESS',
    FORM_HIDING_FAILURE: 'FORM_HIDING_FAILURE',
    FORM_REMOVING: 'FORM_REMOVING',
    FORM_REMOVING_SUCCESS: 'FORM_REMOVING_SUCCESS',
    FORM_REMOVING_FAILURE: 'FORM_REMOVING_FAILURE',
    FORM_DRAFTING: 'FORM_DRAFTING',
    FORM_DRAFTING_SUCCESS: 'FORM_DRAFTING_SUCCESS',
    FORM_DRAFTING_FAILURE: 'FORM_DRAFTING_FAILURE'
};

export default FormStates;
